import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import ExpenseAccountForm from './ExpenseAccountForm';
import styles from '../../styles/expenseAccount.module.css';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ExpenseAccountEdit(props) {
    const classes = useStyles();

    const { onClose, open, expenseId, isMandatoryComment } = props;

    const handleClose = (value) => {
        onClose(value);
    };

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {i18next.t("expenseAccount:titlePage")}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={styles.rootExpenseAccount}>
                <ExpenseAccountForm expenseId={expenseId} isMandatoryComment={isMandatoryComment} onCloseEdit={handleClose} />
            </div>
        </Dialog>
    );
}